<template>
    <div>
        <div>
            <p>测试1</p>
            <div style="background: white">
                <el-upload
                        :on-success="handleAvatarSuccess"
                        :data="uploadData"
                        class="avatar-uploader"
                        :action="action"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </div>
        </div>
        <div style="margin-top: 20px">
            <p>测试二</p>
            <input type="file" @change="fileChange"/>
            <img :src="imageUrl2"/>
        </div>
    </div>

</template>

<script>
    let ossResultProxy = null
    import OssUpload from './OssUpload'


    export default {
        name: 'OssUploadExample',

        components: {},

        props: {},

        data() {
            return {
                uploadData: {},
                action: '',
                imageUrl: null,
                imageUrl2: null,
                mageUrl2Key:null
            }
        },
        computed: {},
        mounted() {

            // this.$store.dispatch('getHomeData')
        },

        methods: {
            handleAvatarSuccess(response) {
                this.imageUrl = ossResultProxy.url
                console.info(ossResultProxy.objectKey)
            },

            async beforeAvatarUpload(file) {

                let ossUpload = new OssUpload()

                let ossResult = await ossUpload.getElOssPolicy(2)

                this.action = ossResult.host
                this.uploadData = ossResult.uploadData
                ossResultProxy = ossResult
                debugger
                return true;
            },

            async fileChange(e){
                let ossUpload = new OssUpload()
                await ossUpload.setOssPolicy(1)
                var files = e.target.files[0]
                let ossResult=await ossUpload.uploadFileForFileStream(files,2)
                console.log('这里是上传图片之后返回的结果')
                console.log(ossResult)
                this.mageUrl2=ossResult.url
                this.mageUrl2Key=ossResult.objectKey
            },


        }
    }
</script>

<style lang="stylus" scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

</style>



// WEBPACK FOOTER //
// src/common/OssUploadExample.vue